module.exports = __webpack_public_path__ + "static/media/sam-jhon.fb41ded7.png";